import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  closeLoginModal: () => void;
  openRemindPasswordModal: () => void;
}

const RemindPasswordLink = ({
  openRemindPasswordModal,
  closeLoginModal,
}: IProps) => {
  const colors = useGetThemeColors();
  return (
    <ChakraText
      _hover={{
        cursor: "pointer",
        textDecoration: "underline",
      }}
      color={colors.primary[500]}
      onClick={() => {
        closeLoginModal();
        openRemindPasswordModal();
      }}
    >
      Zapomniałeś hasło?
    </ChakraText>
  );
};

export { RemindPasswordLink };
